// @dynamic
export class StatusVars {
    public static generalStatus: object = {
        0: 'statPassive',
        1: 'statActive',
        3: 'statCancelled',
        5: 'statDeleted'
    };
    public static repairQuotation2: object = {
        0: 'statPassive',
        1: 'statQuotationCreated',
        2: 'statInRevision',
        3: 'statCancelled',
        4: 'statEntered',
        5: 'statDeleted',
        6: 'statFinalised'
    };
    public static purchaseOrder: object = {
        '-2': 'statSaved',
        1: 'statOrdered',
        2: 'statConfirmed',
        3: 'statCancelled',
        4: 'statArrived',
        7: 'statPartialArrivied'
    };
    public static purchaseTender: object = {
        1: 'statQuotationCreated',
        2: 'statPriceEntered',
        3: 'statPendingOrderConfirmation',
        4: 'statLoggedOffer',
        6: 'statOrdered',
        0: 'statWaitConfirm1',
        7: 'statWaitConfirm2',
        8: 'statWaitConfirmFinal',
        9: 'approvedOpenOrder'
    };
    public static purchaseRequest: object = {
        1: 'statConvertedProposal',
        2: 'statRejected',
        3: 'statPendingOrderConfirmation',
        4: 'statNewRequest',
        6: 'statOrdered',
        7: 'statPartialTendered',
        0: 'statPassive'
    };
    public static repairQuotation: object = {
        1: 'statEntered',
        2: 'statConfirmed',
        3: 'statWaitRevision',
        4: 'statProjectCreated'
    };
    public static project: object = {
        0: 'onSupply',
        1: 'needDetails',
        2: 'Unquoted',
        3: 'cancelled',
        4: 'waitingOrder',
        6: 'ordered',
        7: 'delivered'
    };
    public static workOrder: object = {
        0: 'statWaitingConfirm',
        6: 'statToBeDone',
        1: 'statStarted',
        2: 'statFirstClose',
        3: 'statCancelled',
        4: 'statSecondClose',
        5: 'statDeleted',
        7: 'statWaitingContractorOffer',
        8: 'statThirdClose'
    };
    public static workOrderClassDesign: object = {
        0: 'statNotArrived',
        1: 'statArrived',
        2: 'statApproved'
    };
    public static workOrderProdDesign: object = {
        0: 'statNotArrived',
        2: 'statPublished'
    };
    public static warehouseIntake: object = {
        0: 'statPassive',
        1: 'statInStock',
        2: 'statQuantityControlDeny',
        3: 'statQualityControlDeny',
        5: 'statDeleted',
        6: 'statQuantityControl',
        7: 'statQualityControl'
    };
    public static warehouseWithdraws: object = {
        1: 'statEntered2',
        2: 'statWaitingConfirm',
        3: 'statNotApproved',
        4: 'statConfirmed',
        5: 'statDeleted'
    };
    public static materialLoans: object = {
        1: 'statLent',
        2: 'statRequested',
        3: 'statCancelled',
        4: 'statReplaced'
    };
    public static classImageFile: object = {
        0: 'statNotApproved',
        1: 'statApproved'
    };
    public static reservationStat: object = {
        0: 'vacant',
        1: 'full',
        2: 'reserved'
    };
    public static qcRemarkStat: object = {
        0: 'statEntered',
        1: 'statClosed',
        2: 'statInRevision'
    };
    public static userStartUpStat: object = {
        1: 'userRecord',
        2: 'userPassed',
        3: 'userFailed',
        4: 'approvedDoctor',
        5: 'deniedDoctor',
        6: 'waitedDoctor',
        7: 'approvedChancellery',
        8: 'deniedChancellery',
        9: 'givenKKD'
    };
    public static equipmentDamageFormStat: object = {
        1: 'statWaitEstimation',
        2: 'statWaitEstimationApproval'
    };
    public static orderInvoiceStatus: object = {
        0: 'statNotInvoiced',
        1: 'statInvoiced',
        2: 'statPartialInvoiced'
    };
    public static accPaymentPlanStatus: object = {
        0: 'statNotPaid',
        1: 'statPaid',
        2: 'statDrafted'
    };
    public static accPaymentDrafts: object = {
        0: 'statPassive',
        1: 'statActive',
        2: 'statConfirmed',
        3: 'statCancelled',
        4: 'statPaid',
        6: 'statWaitConfirm1',
        7: 'statWaitConfirm2',
        8: 'statWaitConfirm3',
        9: 'statWaitConfirmFinal'
    };
    public static vesselStatus: object = {
        0: 'statVesselEntered',
        1: 'statVesselConvertedToProject',
        2: 'statVesselTenderProcess',
        3: 'repaired'
    };
    public static vesselTrackStatus: object = {
        1: 'onSupply',
        2: 'waitingOrder',
        3: 'cancelled',
        4: 'ordered',
        6: 'delivered',
        7: 'needDetails',
        8: 'Unquoted',
    };
    public static projectContractorTimingApprovalsStatus: object = {
        0: 'statWaitConfirm1',
        2: 'statConfirmed',
        6: 'statWaitConfirm2',
        7: 'statWaitConfirm3',
        8: 'statWaitConfirm4',
        9: 'statWaitConfirmFinal'
    };
    public static ditStatus: object = {
        0: 'statWaitConfirm1',
        1: 'statSaved',
        2: 'onaylandiIsEmriAc',
        3: 'statCancelled',
        4: 'convertToWorkOrder',
        6: 'statWaitConfirm2',
        7: 'statWaitConfirm3',
        8: 'statWaitConfirm4',
        9: 'takenOnHold'
    };
    public static contractorTimingStatus: object = {
        0: 'Onaya Bekliyor',
        1: 'Kaydedilmiş',
        2: 'Tamamlanmiş',
        3: 'Reddedilmiş'
    };
    public static projectContractorTimingDetailApprovalStatus: object = {
        0: 'statSaved',
        1: 'statWaitConfirm',
        2: 'statConfirmed',
        3: 'statCancelled'
    };

    public static  projectMaterialsPreparationStatus: object = {
        1: 'preparing',
        2: 'prepared',
        3: 'statCancelled',
        0: 'statWaitConfirm',
        4: 'takenOnHold'
    };
    public static  repairProjectRequestsStatus: object = {
        1: 'onaylandiIsEmriAc',
        2: 'workOrderConnected',
        3: 'repeatingEntry',
        0: 'statWaitConfirm',
        4: 'convertToWorkOrder'
    };
    public static equipmentSerialsStatus: object = {
        0: 'kullanilamaz',
        1: 'kullanilabilir',
        2: 'zimmette',
        3: 'inRepair',
        4: 'satilmis'
    };

    public static vesselTenderServiceStatus: object = {
        0: 'statActive',
        2: 'statOrdered',
        3: 'statCancelled',
        9: 'statCancelledOrder',
        4: 'statMakeInvoice',
        6: 'statInvoiced'
    };
}
